import React, { useState } from 'react';
import { get } from 'lodash';

import Grid from '~/components/core/Atomic/Grid/Grid';
import useFormikChangeListener from '~/components/core/Formik/FormikChangeListener';
import SwitchFormik from '~/components/core/Formik/SwitchFormik';
import TextField from '~/components/core/Molecules/Fields/TextField';
import CliveObjectConfig from '~/components/SystemConfiguration/CliveConfiguration/CliveObjectConfig';

import FieldConfigurationCard from '../FieldConfigurationCard/FieldConfigurationCard';

import BaseConfigurationSection from './BaseConfigurationSection';

const ID_PREFIX = 'configuration.triage';
const TITLE = 'Triage';
const KEY = 'triage';
const SECTION_ID = `configuration.${KEY}`;

const TriageSection = () => {
  const [isHidden, setIsHidden] = useState(false);

  // Enforce all supplementary section to be hidden if the section show is set to false
  useFormikChangeListener({
    listenForKeys: [`${SECTION_ID}.active`],
    onChange: (values, _) => {
      !get(values, `${SECTION_ID}.active`, false) ? setIsHidden(true) : setIsHidden(false);
    },
    runOnFirstRender: true,
  });

  return (
    <BaseConfigurationSection title={TITLE} subtitle={`Key: ${KEY}`} isHidden={isHidden} isSection>
      <Grid item xs={6}>
        <TextField label="Display Name" value={TITLE} fullWidth disabled />
      </Grid>
      <Grid item xs={6}>
        <TextField value={KEY} label="Key" fullWidth disabled />
      </Grid>
      <Grid item xs={2}>
        <SwitchFormik id={`${SECTION_ID}.active`} label="Show" hideErrorGap />
      </Grid>
      <Grid item xs={10} /> {/* Spacer */}
      <CliveObjectConfig basePath={SECTION_ID} />
      <FieldConfigurationCard
        idPrefix={ID_PREFIX}
        fieldId="complexity"
        disabledCollapse={isHidden}
        disableCategories
        disableAdd
      />
    </BaseConfigurationSection>
  );
};

export default TriageSection;
